import useAffiliatePageLogic from './hooks/useAffiliatePageLogic'


const AffiliatePage = () => {

   useAffiliatePageLogic()

   return (
      <div />
   )
}

export default AffiliatePage